import { cn } from '@/shared/lib/cn';
import type { UnitPresentation } from './publicationModel';

const TONE: Record<UnitPresentation['tone'], { chip: string; dot: string }> = {
  neutral: { chip: 'bg-card-alt border-line/60', dot: 'bg-ink-faint' },
  progress: { chip: 'bg-navy/5 border-navy/15', dot: 'bg-navy' },
  ok: { chip: 'bg-sage/10 border-sage/20', dot: 'bg-sage' },
  warn: { chip: 'bg-amber/15 border-amber/30', dot: 'bg-amber' },
  error: { chip: 'bg-sealwax/10 border-sealwax/20', dot: 'bg-sealwax' },
};

/** Stand eines Apartments beim Kanalmanager — als Wort, die Farbe trägt nur mit. */
export function PublicationStateChip({ presentation }: { presentation: UnitPresentation }) {
  const tone = TONE[presentation.tone];
  return (
    <p
      className={cn(
        'text-ink inline-flex w-fit items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs',
        tone.chip,
      )}
    >
      <span className="sr-only">Kanalmanager: </span>
      <span aria-hidden className={cn('size-1.5 shrink-0 rounded-full', tone.dot)} />
      <span>{presentation.label}</span>
    </p>
  );
}
